/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface AgentDetails { 
    /**
     * Agent Id.
     */
    agent_id?: string;
    /**
     * The human-friendly name of the agent. Might be a host name, IP address, or a user-specified string.
     */
    agent_name?: string;
    /**
     * Agent Version
     */
    agent_version?: string;
    /**
     * The last time the the agent has called the creds self-rotation API.
     */
    creds_rotated_at?: Date;
    /**
     * The OAuth app client Id created for agent.
     */
    oauth_client_id?: string;
    /**
     * The user who initiated the pairing.
     */
    paired_by?: string;
    /**
     * The time at which the agent has been paired.
     */
    paired_timestamp?: Date;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
}
export namespace AgentDetails {
}


